import {
    AutogenLayoutInvitedCarrierWithPrequalQuickInfo
} from "./autogen/AutogenLayoutInvitedCarrierWithPrequalQuickInfo";

export class InvitedCarrierWithPrequalQuickInfo extends AutogenLayoutInvitedCarrierWithPrequalQuickInfo {

}
